<template>
  <div class="segmented-control">
    <div
      class="segmented-control__pill"
      :style="pillStyle"
    />

    <div
      v-for="(label, key) in items"
      :key="key"
      :ref="key"
      :class="{ 'segmented-control__item--selected': key === modelValue }"
      class="segmented-control__item"
      :tabindex="key !== modelValue && '0' || null"
      @click="$emit('update:modelValue', key)"
      @keypress="$emit('update:modelValue', key)"
      v-html="label"
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true
    },
    items: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data: () => ({
    enableAnimation: false,
    pillStyle: {}
  }),
  watch: {
    modelValue: {
      handler(val) {
        this.$nextTick(() => {
          if (val && this.$refs[val]) {
            const targetItem = this.$refs[val][0]
            if (targetItem) {
              this.pillStyle = {
                width: targetItem.clientWidth + 'px',
                left: targetItem.offsetLeft + 'px'
              }
            }
          } else {
            this.pillStyle = {}
          }
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import "~@ui/styles/src/scss/utils/lib";

$height: 24px;
$min-item-width: 40px;

.segmented-control {
  position: relative;
  display: inline-flex;
  height: $height;
  background-color: $grey-70;
  border-radius: 3px;

  &__pill {
    position: absolute;
    top: 1px;
    bottom: 1px;
    z-index: 1;
    background-color: $grey-95;
    border-radius: 2px;
    transition: all ease-in-out 0.25s;
  }

  &__item {
    z-index: 2;
    min-width: $min-item-width;
    margin: 0 1px;
    padding: 0 12px;
    font-size: 12px;
    line-height: $height - 1;
    text-align: center;
    cursor: pointer;
    transition: color ease 0.25s;

    &:hover,
    &:focus {
      color: $grey-55;
    }

    &--selected {
      cursor: default;
      pointer-events: none;
    }
  }
}
</style>
